const init = () => {
    // clear cache option
    $('.btn__clear-transients').click((e) => {
        const thisElem = $(e.currentTarget);
        let xhr; // eslint-disable-line init-declarations
        thisElem.attr('disabled', true);

        function fn() {
            // 4 = DONE
            // if it's done, stop the ajax calls and clear the interval
            if (xhr && xhr.readyState !== 4) {
                xhr.abort();
                clearInterval(checkFinished);
            }

            xhr = $.ajax({
                url: '/wp/wp-admin/admin-ajax.php?action=delete_transients',
                success: () => {
                    clearInterval(checkFinished); // eslint-disable-line no-use-before-define
                    location.reload();
                },
            });
        }

        fn();
        const checkFinished = setInterval(fn, 9990);
    });
};

export { init };
